var _style, _path, _path2, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtmlTechIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    style: {
      enableBackground: "new 0 0 45 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F2F2F2;}\r\n\t.st1{fill:#E64C18;}\r\n\t.st2{fill:#F36518;}\r\n\t.st3{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45,22.5c0,7.2-3.4,13.7-8.7,17.8c-3.8,3-8.6,4.7-13.8,4.7c-5.1,0-9.9-1.7-13.7-4.6C3.5,36.3,0,29.8,0,22.5 C0,10.1,10.1,0,22.5,0S45,10.1,45,22.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.8,10.5l-2.6,29.8c-3.8,3-8.6,4.7-13.8,4.7c-5.1,0-9.9-1.7-13.7-4.6L6.2,10.5H38.8z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "22.5,13.3 22.5,44.3 33.3,41.3 35.7,13.3 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "12.4,17.2 13.4,29.6 27.4,29.6 26.9,34.8 22.5,36 18,34.7 17.9,31.5 13.6,31.5 14.1,37.8 22.5,40.2  31,37.8 32,25.4 17.3,25.4 16.9,21.4 16.9,21.4 32.4,21.3 32.7,17.2 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "13.3,1.5 13.3,3.6 11.2,3.6 11.2,1.5 9.3,1.5 9.3,7.6 11.2,7.6 11.2,5.6 13.3,5.6 13.3,7.6 15.2,7.6 15.2,1.5 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "21.9,1.5 16.1,1.5 16.1,3.6 18,3.6 18,7.7 20,7.7 20,3.6 21.9,3.6 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "32.8,5.7 32.8,1.5 30.8,1.5 30.8,5.7 30.8,7.7 32.8,7.7 35.8,7.7 35.8,5.7 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "27.7,1.5 26.3,3.7 24.8,1.5 22.8,1.5 22.8,7.7 24.8,7.7 24.8,4.6 26.3,6.8 27.7,4.6 27.7,7.7 29.7,7.7 29.7,1.5 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlTechIcon);
export default __webpack_public_path__ + "static/media/html-tech-icon.a81a17103adf5820078f332d72ceff27.svg";
export { ForwardRef as ReactComponent };